module.exports = __webpack_public_path__ + "static/media/smartBanner_screenshot.57264b5b.png";